import * as permissions from '../auth/permissions';

// eslint-disable-next-line import/prefer-default-export
export const fetchPermissions = () => (
    [
        permissions.READ_CSA_SUMMARY,
        permissions.EXECUTE_IMPACT_ANALYSIS,
        permissions.READ_STATIC_DATA,
        permissions.EXECUTE_WEB_JOBS
    ]
);
